import SpinningCircle from './SpinningCircle';

export default SpinningCircle;
